var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5099 13.3568C28.2032 12.7539 29.0911 12.4219 30.0099 12.4219C30.9287 12.4219 31.8165 12.7539 32.5099 13.3568C38.2499 18.2768 44.3799 25.7468 44.3799 34.1968C44.3799 43.8868 37.9499 48.5468 30.0199 48.5468C22.0899 48.5468 15.6499 43.8868 15.6499 34.1968C15.6499 25.7468 21.7699 18.2768 27.5099 13.3568Z",
    fill: "#F6D073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreasy);
export default __webpack_public_path__ + "static/media/greasy.d2ec811cc8a5c2b18eaf83e7273ea97f.svg";
export { ForwardRef as ReactComponent };